import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { initSentry } from './observability/sentry';
import App from './App';
import { AuthProvider } from './auth/AuthProvider';
import { ErrorFallback } from './components/ErrorFallback';
import { ConfirmProvider } from './components/ui/Confirm';
import { ToastProvider } from './components/ui/Toast';
import { ThemeProvider } from './theme/ThemeProvider';
import './index.css';

// Antes de qualquer render: erros no boot também precisam ser capturados.
initSentry();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider>
      <Sentry.ErrorBoundary
        fallback={({ resetError, eventId }) => (
          <ErrorFallback resetError={resetError} eventId={eventId ?? undefined} />
        )}
      >
        <BrowserRouter>
          <ToastProvider>
            <ConfirmProvider>
              <AuthProvider>
                <App />
              </AuthProvider>
            </ConfirmProvider>
          </ToastProvider>
        </BrowserRouter>
      </Sentry.ErrorBoundary>
    </ThemeProvider>
  </React.StrictMode>,
);
